module.exports = __webpack_public_path__ + "img/7_uk.d410e8c4.svg";